import type { Context } from 'hono';
import { z } from 'zod';

type ErrorStatusCode = number;

export const ProblemDetailsSchema = z
  .object({
    type: z.string().optional(),
    title: z.string().optional(),
    status: z.number(),
    detail: z.string().optional(),
    instance: z.string().optional(),
  })
  .loose(); // [key: string]: unknown を許可

export type ProblemDetails = z.infer<typeof ProblemDetailsSchema>;

const createErrorResponse = (
  c: Context,
  config: {
    title?: string;
    status: ErrorStatusCode;
    detail?: string;
    type?: string;
    [key: string]: unknown;
  }
): Response => {
  const problemDetails: ProblemDetails = {
    ...config,
    instance: c.req.url,
  };

  return new Response(JSON.stringify(problemDetails), {
    status: config.status,
    headers: {
      'Content-Type': 'application/problem+json',
    },
  });
};

export default createErrorResponse;
